module.exports = __webpack_public_path__ + "assets/cover_2_LQ-373b16.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./Content/images/cover_2_LQ.jpg
 ** module id = 919
 ** module chunks = 2
 **/